import { gql } from "@apollo/client";

export const UPDATE_SUNDRY_INVOICE = gql`
  mutation updateSundryInvoice($invoiceId: String!, $invoiceItems: [InvoiceItemInput]!) {
    updateSundryInvoice(invoiceId: $invoiceId, invoiceItems: $invoiceItems) {
      id
    }
  }
`;